export default __webpack_public_path__ + "media/img_04/300@2x-a5f3e26e.jpg";